<template>
  <div>
    <div class="floating-img d-none d-md-block"></div>
    <div class="container">
      <div class="row align-items-center" style="min-height: 75vh">
        <div class="col-md-7 text-center text-md-left">
          <h1 class="big-title">
            Besoin d'un copilote<br />pour gérer
            <span>{{ mode === "pea" ? "votre PEA" : "vos bags" }}&nbsp;?</span>
          </h1>
          <h4 class="description-title">
            Avec moni, prenez dès maintenant des décisions <br />
            éclairées sur vos investissements. <br />
            Suivez et optimisez vos portefeuilles d'actions<br />
            européennes, américaines et vos cryptomonnaies.
          </h4>
          <div class="my-4 text-center text-md-left">
            <a
              target="_blank"
              href="https://apps.apple.com/fr/app/peamoni/id1560663001"
              class="m-2"
            >
              <img src="img/app_store.svg" />
            </a>
            <a
              target="_blank"
              href="https://play.google.com/store/apps/details?id=com.peamoni.app"
              class="m-2"
            >
              <img src="img/play_store.png" style="height: 40px;" />
            </a>
          </div>
        </div>
        <div class="col-md-5"></div>
      </div>

      <div class="row align-items-center" style="min-height: 70vh">
        <div class="d-none d-md-block col-md-6">
          <figure class="ie-non-standard-hero-shape">
            <svg
              x="0px"
              y="0px"
              viewBox="10 12 878.9 907"
              style="enable-background:new 10 12 878.9 907;"
              xml:space="preserve"
              class="injected-svg js-svg-injector"
              data-img-paths='[ {"targetId": "#imageShape1", "newPath": "/img/bg5.jpeg"},
                            {"targetId": "#imageShape2", "newPath": "/img/bg5.jpeg"}]'
              data-parent="#SVGNonStandardHeroShape"
            >
              <g>
                <defs>
                  <path
                    id="firstShape"
                    d="M299.27,772.72s-24.67-76.08-131.42-51.33C62.82,745.74,81.48,563.56,92,495.71S193.94,92.18,454.77,76.46,658.58,250.62,632.75,306s-78.37,115.53,16.76,295.77-89.33,258.1-129.36,265.84S375.3,912.41,299.27,772.72Z"
                  ></path>
                </defs>
                <clipPath id="secondShape">
                  <use xlink:href="#firstShape" style="overflow:visible;"></use>
                </clipPath>
                <g clip-path="url(#secondShape)">
                  <image
                    id="imageShape1"
                    style="overflow:visible;"
                    width="1000"
                    height="1000"
                    xlink:href="/img/bg5.jpeg"
                    transform="matrix(0.9488 0 0 0.9488 25 53.1187)"
                  ></image>
                </g>
              </g>
              <g>
                <defs>
                  <path
                    id="thirdShape"
                    d="M741.49,643q-2.58-.31-5.17-.4c-12-.45-46.58-14.37-79.24-71.85-17.81-31.35-47.32-96.41-37.88-167.21,7.84-58.79,38.38-97.1,48.34-130.64,24.82-83.61,66.62-77.07,98-77.07,15.93,0,31.1,14.82,39.21,26.39,11.55,16.48,19.72,46.24-9.1,93.32-60.66,99.07,14.09,139.33-.93,239.68C781.72,641.8,750,644,741.49,643Z"
                  ></path>
                </defs>
                <clipPath id="fourthShape">
                  <use xlink:href="#thirdShape" style="overflow:visible;"></use>
                </clipPath>
                <g
                  transform="matrix(1 0 0 1 0 0)"
                  clip-path="url(#fourthShape)"
                >
                  <image
                    id="imageShape2"
                    style="overflow:visible;"
                    width="1000"
                    height="1000"
                    xlink:href="/img/bg5.jpeg"
                    transform="matrix(0.9488 0 0 0.9488 25 53.1187)"
                  ></image>
                </g>
              </g>
            </svg>
          </figure>
        </div>
        <div class="col-12 col-md-5">
          <h1 class="mb-0">Prenez les commandes</h1>
          <h4 class="text-primary mb-4">et faites décoller votre épargne.</h4>
          <h4>
            Moni vous aide à prendre des décisions éclairées sur vos
            investissements grâce à des outils techniques et du contenu adapté à
            votre profil. <br /><br />
            Indicateurs, screeners, alertes... vous avez tous les instruments
            sous les yeux, il ne reste plus qu'à dérouler vos plans de vols.
          </h4>
        </div>
      </div>

      <div
        class="row justify-content-center my-5 pt-5"
        style="min-height: 70vh"
      >
        <div class="col-12 text-center">
          <h1>Faites les bons choix pour votre prochaine destination.</h1>
        </div>
        <div class="col-lg-3 text-center my-2">
          <div class="icon icon-primary mb-3" style="font-size: 3em">
            <i class="tim-icons icon-sound-wave"></i>
          </div>
          <div class="description">
            <h3 class="info-title">Screeners et indicateurs</h3>
            <p class="description">
              Découvrez les valeurs qui sont en tendances haussières, et affinez
              vos recherches en fonction de votre profil d'investisseur.
            </p>
          </div>
        </div>
        <div class="col-lg-3 text-center my-2">
          <div class="icon icon-warning mb-3" style="font-size: 3em">
            <i class="tim-icons icon-money-coins"></i>
          </div>
          <div class="description">
            <h3 class="info-title">Money<br />management</h3>
            <p class="description">
              Achetez le bon nombre
              {{ mode === "pea" ? "d'actions" : "de crypto" }} et maitrisez le
              risque de chaque position grace à la calculette intégrée au site.
            </p>
          </div>
        </div>
        <div class="col-lg-3 text-center my-2">
          <div class="icon icon-info mb-3" style="font-size: 3em">
            <i class="tim-icons icon-time-alarm"></i>
          </div>
          <div class="description">
            <h3 class="info-title">Rappels et notifications</h3>
            <p class="description">
              Votre copilote vous aide à suivre et gérer votre portefeuille
              grace aux alertes : remonter ou placer des stops, prendre des
              profits, pyramider...
            </p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-7 mx-auto">
          <div class="text-center">
            <h1 class="mb-1">Envie d'essayer ?</h1>
            <h4 class="text-primary mb-4">
              Connectez-vous maintenant à votre tableau de bord.
            </h4>
          </div>
          <card class="card-register card-white">
            <template slot="header">
              <img
                class="card-img"
                src="img/card-primary.png"
                alt="Card image"
              />
              <h4 class="card-title">Connexion</h4>
            </template>

            <div class="text-center my-4 pt-3">
              <div>
                <button
                  class="btn btn-simple btn-twitter"
                  @click="twitterSignIn"
                >
                  <i class="fab fa-twitter"></i> Se connecter avec Twitter
                </button>
              </div>
              <div>
                <button class="btn btn-simple btn-google" @click="googleSignIn">
                  <i class="fab fa-google"></i> Se connecter avec Google
                </button>
              </div>
              <div>
                <button class="btn btn-simple btn-apple" @click="appleSignIn">
                  <i class="fab fa-apple"></i> Se connecter avec Apple
                </button>
              </div>
            </div>

            <span class="mx-3">
              En poursuivant, vous acceptez les
              <router-link class="" tag="a" to="/terms"
                >conditions d'utilisation</router-link
              >.
            </span>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "welcome-page",
  components: {},
  methods: {
    twitterSignIn() {
      this.$store.dispatch("auth/signIn", "Twitter");
    },
    googleSignIn() {
      this.$store.dispatch("auth/signIn", "Google");
    },
    appleSignIn() {
      this.$store.dispatch("auth/signIn", "Apple");
    }
  },
  computed: {
    ...mapGetters({
      mode: "auth/mode"
    })
  }
};
</script>
<style>
.big-title {
  font-size: 50px;
  font-weight: 600;
  line-height: 64px;
}

.big-title span {
  background: linear-gradient(-45deg, #e14eca, #e14eca, #ba54f5, #ba54f5);
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
  -webkit-animation: stripes 10s ease-in-out infinite;
  animation: stripes 10s ease-in-out infinite;
  background-size: 200% 100%;
}

@-webkit-keyframes stripes {
  0% {
    background-position: 0px 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0px 50%;
  }
}

@keyframes stripes {
  0% {
    background-position: 0px 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0px 50%;
  }
}

.description-title {
  color: #c0b6c0;
  font-weight: 500;
}

.floating-img {
  position: absolute;
  height: 65vh;
  left: 55%;
  border-radius: 10px 0 0 10px;
  background-image: url("/img/home_screenshot.png");
  background-size: cover;
  background-position: left;
  background-repeat: no-repeat;
  width: 45%;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
}

h1 {
  font-weight: 600;
  font-size: 2.6em;
}
</style>
